import { Flex } from "@chakra-ui/react";
import PublicLayout from "../../public/Layout/layout";
import OtpForm from "./OtpForm";
const OTP = () => {
  return (
    <PublicLayout color="main_1" bg="white" register={true}>
      <Flex
        bg="whiteAlpha.700"
        flexDirection="column"
        p={10}
        mt="150px"
        w="100%"
        h="100%"
        alignItems="end"
      >
        <OtpForm />
      </Flex>
    </PublicLayout>
  );
};

export default OTP;
